import React from "react";
import Helmet from "react-helmet";
import Scrollchor from "react-scrollchor";

import NavBar from "../../components/NavBar";
import { H1, H4, P, Description } from "../../components/typography";
import { getGraphNode } from "../../selectors";
import Emphasis from "../../components/atoms/Emphasis";
import Section from "../../components/blocks/Section";
import { ShowMobile } from "../../components/blocks/Responsive";
import Spacer from "../../components/blocks/Spacer";
import { HFlexFlipper } from "../../components/blocks/Flex";
import Pad from "../../components/blocks/Pad";
import Image from "../../components/Image";
import Background from "../../components/blocks/Background";
import { ArrowBody } from "../../components/ArrowLink";
import Virginia, { VirginiaHero } from "../../components/Virginia";

import Benefits from "../../components/BenefitGrid";
import CvilleList from "../../components/CvilleList";
import PositionList from "../../components/PositionList";
import favicon from "../../../assets/logofavcon@2x.png";

const CareerText = P.extend`
  font-size: 1.2rem;
  line-height: 1.6;
`;

export default class CareerPage extends React.Component {
  render() {
    const content = getGraphNode(this.props.data, "CareerPage");
    const jobs = content.positions;
    return (
      <div>
        <Helmet
          title="Contraline Careers"
          meta={[{ name: "Contraline", content: "Careers" }]}
        >
          <link rel="icon" type="image/png" href={favicon} />
        </Helmet>
        <NavBar color="dark" background="greyLight" />
        <Background color="greyLight">
          <Section padLarge noBorder fixed>
            <VirginiaHero>
              <Virginia />
              <div className="intro">
                <H1 serif weight="bold">
                  {content.headerTitle}
                </H1>
                <CareerText>
                  {content.virginiaHeroText.virginiaHeroText}
                </CareerText>
                <CareerText color="teal" style={{ paddingTop: ".5rem" }}>
                  <Scrollchor
                    to="#open-positions"
                    className="nav-link"
                    style={{
                      position: "relative",
                      cursor: "pointer",
                      color: "inherit",
                      textDecoration: "none"
                    }}
                    animate={{ duration: 600 }}
                  >
                    <ArrowBody>
                      {content.openPositionLink}
                    </ArrowBody>
                  </Scrollchor>
                </CareerText>
              </div>
            </VirginiaHero>
          </Section>
          <Spacer span={3} />
          <Section>
            <Image
              alt="Research at Contraline"
              image={content.careerGrid.responsiveResolution.src}
              full={true}
              style={{ width: "100%", paddingTop: "2rem" }}
            />
          </Section>
          <Section>
            <Emphasis>
              <H4>
                {content.benefitsTitle}
              </H4>
            </Emphasis>
            <Benefits list={content.benefitsList.benefitsList.split("|")} />
          </Section>
        </Background>
        <div id="open-positions" />
        <Section>
          <Emphasis>
            <H4>
              {content.openPositionsTitle}
            </H4>
          </Emphasis>
          <PositionList list={jobs} />
        </Section>
        <Section>
          <Emphasis>
            <H4>
              {content.locationTitle}
            </H4>
          </Emphasis>
          <Spacer span={3} />
          <HFlexFlipper align="flex-start">
            <Pad h={1} mh={0.5}>
              <Image
                full={true}
                align="center"
                caption={content.cvilleImageCaption}
                image={content.cvilleImage.responsiveResolution.src}
              />
            </Pad>
            <ShowMobile>
              <Spacer span={2.5} />
            </ShowMobile>
            <CvilleList benefits={content.cvilleImageList.entries} />
          </HFlexFlipper>
        </Section>
      </div>
    );
  }
}

export const pageQuery = graphql`
  query CareerPageQuery {
    allContentfulCareerPage {
      edges {
        node {
          headerTitle
          virginiaHeroText {
            virginiaHeroText
          }
          openPositionLink
          careerGrid {
            responsiveResolution(width: 1200, quality: 70) {
              src
            }
          }
          benefitsTitle
          benefitsList {
            benefitsList
          }
          openPositionsTitle
          positions {
            id
            title
            description {
              description
            }
          }
          locationTitle
          cvilleImage {
            responsiveResolution(width: 1000, quality: 70) {
              src
            }
          }
          cvilleImageCaption
          cvilleImageList {
            entries {
              title
              description
            }
          }
        }
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/pages/careers/index.js